<template>
  <div>
    <ImportData :isFlag="importdata" @refreshData="getData"></ImportData>
    <AddGoods
      :isFlag="addgoods"
      :list="goods_list"
      @refreshData="getGoods"
    ></AddGoods>
    <div class="flex between" style="padding-right: 20px">
      <div class="page_title">新建开方活动</div>
      <el-button type="primary" size="medium" @click="back" style="width: 120px"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="title">活动类型</div>
        <div class="flex" style="margin-bottom: 20px">
          <div
            class="checkbox"
            @click="changeType(1)"
            :style="act_type == 1 ? 'background:#c0d0c7' : 'background:#f5f5f5'"
          >
            <div class="big_word">开方数量活动</div>
            <div style="color: #878787">根据开方数量和每方药费核算目标</div>
          </div>
          <div
            class="checkbox"
            @click="changeType(2)"
            :style="act_type == 2 ? 'background:#c0d0c7' : 'background:#f5f5f5'"
          >
            <div class="big_word">开方金额活动</div>
            <div style="color: #878787">根据累计开方药费合计总金额核算目标</div>
          </div>
        </div>
        <el-form
          :model="info"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="rule-Form"
        >
          <div class="title">基本信息</div>
          <el-form-item label="活动名称" prop="act_name">
            <el-input
              v-model="info.act_name"
              maxlength="8"
              style="width: 300px"
              placeholder="不超过8个字"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动备注">
            <el-input
              v-model="info.remark"
              maxlength="20"
              style="width: 300px"
              placeholder="不超过20个字"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间" prop="act_time">
            <el-date-picker
              style="width: 300px"
              v-model="info.act_time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :disabled="act_id"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="活动奖励结算时间" prop="settle_day">
            <div>
              在处方订单完成结算后
              <el-input-number
                v-model="info.settle_day"
                :min="0"
                :max="100"
                :controls="false"
                placeholder="请输入数字"
                style="width: 110px; margin: 0 5px"
              ></el-input-number
              >天结算活动奖励
            </div>
            <div style="color: #999; font-size: 12px; margin-top: -10px">
              示例说明：1月1日完成收货，0天表示1月2日完成处方订单结算的当天凌晨4:00后完成活动奖励结算
            </div>
          </el-form-item>
          <el-form-item
            label="活动链接"
            prop="act_url"
            style="margin-top: 30px"
          >
            <el-input
              v-model="info.act_url"
              style="width: 300px"
              placeholder="请输入活动链接"
            ></el-input>
            <span style="color: #999; font-size: 12px; margin-left: 10px"
              >用于医生端展示活动的页面URL，每次活动需单独定制</span
            >
          </el-form-item>
          <el-form-item
            label="活动参与医生"
            prop="doctor_auth"
            style="margin-top: -10px"
          >
            <el-radio-group v-model="info.doctor_auth">
              <el-radio :label="1">全部医生</el-radio>
              <el-radio :label="2">部分医生</el-radio>
            </el-radio-group>
            <el-button
              v-if="info.doctor_auth === 2"
              type="primary"
              size="mini"
              style="margin-left: 10px"
              @click="addData"
              >导入手机号</el-button
            >
          </el-form-item>

          <el-form-item
            label="活动头图"
            prop="top_image"
            style="margin-top: -10px"
          >
            <UploadImg
              :f_thumb="info.top_image"
              :key="info.top_image"
              :f_thumb_str="info.top_image_str"
              @emitImg="emitImg"
            ></UploadImg>
          </el-form-item>

          <el-form-item
            label="活动背景色"
            prop="bg_color"
            style="margin-top: -10px"
          >
            <el-input
              v-model="info.bg_color"
              style="width: 300px"
              placeholder="请输入活动背景色，如#ffffff"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动规则" prop="desc" style="margin-top: -10px">
            <wangeditorNew
              ref="editorBox"
              @changeCheck="changeCheck"
              :margins="margins"
            />
          </el-form-item>

          <el-form-item
            v-if="info.doctor_auth === 2"
            style="padding-right: 20px; margin-top: -20px; margin-bottom: 120px"
          >
            <div style="margin: -15px 0 -6px 0">
              已选择{{ doctor_length }}位医生参与
            </div>
            <el-input
              type="textarea"
              v-model="info.doctor_string"
              :rows="6"
              placeholder="请填写指定医生手机号，多个用英文逗号隔开"
              onkeyup="this.value=this.value.replace(/[ ]/g,'')"
              @keydown.enter.native="handleTextareaKeydown"
            >
            </el-input>
          </el-form-item>
          <div style="margin-bottom: 20px">
            <span class="title">活动奖励</span>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="addItem"
              >增加奖励节点</el-button
            >
          </div>
          <!-- 开方数量活动 -->
          <div v-if="act_type == 1">
            <div
              v-for="(item, index) in numList"
              :key="index"
              class="list_item"
            >
              <div class="flex_between">
                <div>
                  <div>
                    <span class="item_title">奖励名称</span>
                    <el-input
                      v-model="item.rule_name"
                      style="width: 200px"
                      maxlength="10"
                      placeholder="不超过十个字"
                    >
                    </el-input>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">结算条件</span>
                    <span>开方数量达到</span>
                    <el-input-number
                      v-model="item.pre_num"
                      :min="1"
                      :max="999"
                      :precision="0"
                      :controls="false"
                      style="width: 90px; margin: 0 5px"
                      size="medium"
                    ></el-input-number>
                    <span>且每方药费达到</span>
                    <el-input-number
                      v-model="item.drug_price"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :controls="false"
                      style="width: 90px; margin: 0 5px"
                      size="medium"
                    ></el-input-number>
                    <span>元</span>
                  </div>
                  <div class="align-center">
                    <span class="item_title">奖励图片</span>
                    <div class="reward_img">
                      <el-upload
                        class="avatar-uploader"
                        name="image"
                        accept=".png,.jpeg,.jpg"
                        :action="uploadUrl"
                        :data="uploadExtraData"
                        :headers="uploadHeaders"
                        :show-file-list="false"
                        :on-success="
                          (res) => {
                            return handleAvatarSuccess(res, index, 'numList');
                          }
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="item.reward_img"
                          :src="item.reward_img_str"
                          class="avatar"
                        />
                        <div v-else>
                          <i class="el-icon-plus uploader-icon"></i>
                        </div>
                      </el-upload>
                    </div>
                  </div>
                  <div>
                    <span class="item_title">奖励类型</span>
                    <el-radio v-model="item.reward_type" :label="1"
                      >奖金奖励</el-radio
                    >
                    <span v-if="item.reward_type == 1">
                      <el-input-number
                        v-model="item.reward_money"
                        :min="0"
                        :max="9999"
                        :precision="0"
                        :controls="false"
                        style="width: 90px; margin: 0 5px"
                        size="medium"
                      ></el-input-number
                      >元
                    </span>
                  </div>
                  <div style="padding-left: 80px; margin-top: 10px">
                    <el-radio v-model="item.reward_type" :label="2"
                      >奖励物品</el-radio
                    >
                    <el-button
                      v-if="item.reward_type == 2"
                      type="primary"
                      size="mini"
                      style="margin-left: 5px"
                      @click="addGoodsDia('numList', index, item.content)"
                      >添加/编辑物品</el-button
                    >
                  </div>
                </div>
                <div class="btnbox">
                  <div class="column-between">
                    <el-button
                      type="danger"
                      size="mini"
                      style="margin-bottom: 25px"
                      @click="delItem('numList', index)"
                      >删除</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      style="margin-bottom: 5px"
                      @click="changeSort('numList', 1, index)"
                      v-if="index != 0"
                      >上移</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      v-if="index != numList.length - 1"
                      @click="changeSort('numList', 2, index)"
                      >下移</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 开方金额活动 -->
          <div v-if="act_type == 2">
            <div
              v-for="(item, index) in priceList"
              :key="index"
              class="list_item"
            >
              <div class="flex_between">
                <div>
                  <div>
                    <span class="item_title">奖励名称</span>
                    <el-input
                      v-model="item.rule_name"
                      style="width: 200px"
                      maxlength="10"
                      placeholder="不超过十个字"
                    >
                    </el-input>
                  </div>
                  <div style="margin: 14px 0">
                    <span class="item_title">结算条件</span>
                    <span>开方药费总金额达到</span>
                    <el-input-number
                      v-model="item.total_drug_price"
                      :min="0"
                      :max="999999"
                      :precision="0"
                      :controls="false"
                      style="width: 90px; margin: 0 5px"
                      size="medium"
                    ></el-input-number>
                    <span>元</span>
                  </div>
                  <div class="align-center">
                    <span class="item_title">奖励图片</span>
                    <div class="reward_img">
                      <el-upload
                        class="avatar-uploader"
                        name="image"
                        accept=".png,.jpeg,.jpg"
                        :action="uploadUrl"
                        :data="uploadExtraData"
                        :headers="uploadHeaders"
                        :show-file-list="false"
                        :on-success="
                          (res) => {
                            return handleAvatarSuccess(res, index, 'priceList');
                          }
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="item.reward_img"
                          :src="item.reward_img_str"
                          class="avatar"
                        />
                        <div v-else>
                          <i class="el-icon-plus uploader-icon"></i>
                        </div>
                      </el-upload>
                    </div>
                  </div>
                  <div>
                    <span class="item_title">奖励类型</span>
                    <el-radio v-model="item.reward_type" :label="1"
                      >奖金奖励</el-radio
                    >
                    <el-input-number
                      v-if="item.reward_type == 1"
                      v-model="item.reward_money"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :controls="false"
                      style="width: 90px; margin: 0 5px"
                      size="medium"
                    ></el-input-number
                    >元
                  </div>
                  <div style="padding-left: 80px; margin-top: 10px">
                    <el-radio v-model="item.reward_type" :label="2"
                      >奖励物品</el-radio
                    >
                    <el-button
                      v-if="item.reward_type == 2"
                      type="primary"
                      size="mini"
                      style="margin-left: 5px"
                      @click="addGoodsDia('priceList', index, item.content)"
                      >添加/编辑物品</el-button
                    >
                  </div>
                </div>
                <div class="btnbox">
                  <div class="column-between">
                    <el-button
                      type="danger"
                      size="mini"
                      style="margin-bottom: 25px"
                      @click="delItem('priceList', index)"
                      >删除</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      style="margin-bottom: 5px"
                      @click="changeSort('priceList', 1, index)"
                      v-if="index != 0"
                      >上移</el-button
                    >
                    <el-button
                      plain
                      size="mini"
                      @click="changeSort('priceList', 2, index)"
                      v-if="index != priceList.length - 1"
                      >下移</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div style="margin-top: 50px; padding-left: 260px">
          <el-button type="primary" style="width: 100px" @click="submitForm"
            >保 存</el-button
          >
          <el-button plain style="width: 100px">取 消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImportData from "./ImportData.vue";
import AddGoods from "./AddGoods.vue";
import constant from "../../../service/common/constant";
import UploadImg from "@/components/uploadImg/index";
import wangeditorNew from "../../imgtext/wangeditorNew.vue";
export default {
  data() {
    return {
      page_title: "新增活动",
      act_id: false,
      act_type: 1,
      info: {
        act_id: 0,
        act_type: 1,
        act_name: "",
        remark: "",
        act_time: "",
        settle_day: "",
        act_url: "",
        doctor_auth: 1,
        doctor_string: "",
        rule_obj: "",
        top_image: "",
        top_image_str: "",
        bg_color: "",
        desc: "",
      },
      margins: 1,
      rules: {
        act_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        act_time: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        settle_day: [
          {
            required: true,
            message: "请输入活动奖励结算时间",
            trigger: "blur",
          },
        ],
        act_url: [
          { required: true, message: "请填写活动链接", trigger: "blur" },
        ],
        doctor_auth: [
          { required: true, message: "请选择活动参与医生", trigger: "blur" },
        ],

        top_image: [{ required: true, message: "请上传", trigger: "blur" }],

        bg_color: [{ required: true, message: "请输入", trigger: "blur" }],

        desc: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
      numList: [
        {
          rule_name: "",
          pre_num: "",
          drug_price: 0,
          reward_type: 1, //1奖励金额，2奖励物品
          reward_img: "",
          reward_img_str: "",
          reward_money: "",
          content: [], //奖励的物品
        },
      ],
      priceList: [
        {
          rule_name: "",
          drug_price: "",
          reward_type: 1, //1奖励金额，2奖励物品
          reward_img: "",
          reward_img_str: "",
          reward_money: "",
          content: [], //奖励的物品
        },
      ],
      importdata: false,
      addgoods: false,
      listName: "",
      index: "",
      goods_list: [],
    };
  },
  components: {
    ImportData,
    AddGoods,
    UploadImg,
    wangeditorNew,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    doctor_length() {
      if (this.info.doctor_string) {
        let arr = this.info.doctor_string.split(",");
        return arr.length;
      } else {
        return 0;
      }
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "api/platform/upload/uploadFile";
      } else {
        return "platform/upload/uploadFile";
      }
    },
    uploadHeaders: function() {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  methods: {
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    handleTextareaKeydown() {
      let e = window.event || arguments[0];
      if (e.key === "Enter" || e.code === "Enter" || e.keyCode == 13) {
        e.returnValue = false;
        return false;
      }
    },
    //提交添加
    submitForm() {
      this.info.desc = this.$refs.editorBox.editor.getHtml();
      if (!this.info.desc) {
        this.$message.error("请填写活动规则");
        return false;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.info;

          if (data.doctor_auth == 2 && !data.doctor_string) {
            this.$message.error("请填写指定医生手机号");
            return false;
          }
          // if (data.doctor_auth == 2 && data.doctor_string) {
          //   let reg = /^(1[3456789])d{9}$/;
          //   let arr = data.doctor_string.split(',');
          // }
          data.start_time = data.act_time[0];
          data.end_time = data.act_time[1];
          data.act_type = this.act_type;
          //数量
          if (this.act_type == 1) {
            for (let i = 0; i < this.numList.length; i++) {
              if (
                !this.numList[i].rule_name ||
                !this.numList[i].pre_num ||
                !this.numList[i].reward_img
              ) {
                this.$message.error("请完善活动奖励规则");
                return false;
              }
              if (
                this.numList[i].reward_type == 2 &&
                !this.numList[i].content.length
              ) {
                this.$message.error("请填写活动物品奖励");
                return false;
              }
            }
            data.rule_obj = this.numList.map((item, index) => {
              item.sort = index;
              return item;
            });
          }

          //金额
          if (this.act_type == 2) {
            for (let i = 0; i < this.priceList.length; i++) {
              if (
                !this.priceList[i].rule_name ||
                !this.priceList[i].reward_img
              ) {
                this.$message.error("请完善活动奖励规则");
                return false;
              }
              if (
                this.priceList[i].reward_type == 2 &&
                !this.priceList[i].content.length
              ) {
                this.$message.error("请填写活动物品奖励");
                return false;
              }
            }
            data.rule_obj = this.priceList.map((item, index) => {
              item.sort = index;
              return item;
            });
          }

          this.axios
            .post("platform/doctor/saveDoctorActivity", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("保存成功");
                this.back();
              }
            });
        }
      });
    },
    changeType(act_type) {
      this.act_type = act_type;
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },

    //获取医生电话
    getData(code_array) {
      if (this.info.doctor_string) {
        let string = this.info.doctor_string.split(",");
        let arr = string.concat(code_array);
        this.info.doctor_string = arr.toString();
      } else {
        this.info.doctor_string = code_array.toString();
      }
    },
    //增加节点
    addItem() {
      //开方数量活动
      if (this.act_type == 1) {
        let data = {
          rule_name: "",
          pre_num: "",
          drug_price: 0,
          reward_type: 1,
          reward_money: "",
          reward_img: "",
          reward_img_str: "",
          content: [],
        };
        this.numList.push(data);
      }
      //开方金额活动
      if (this.act_type == 2) {
        let data = {
          rule_name: "",
          drug_price: "",
          reward_type: 1,
          reward_money: "",
          reward_img: "",
          reward_img_str: "",
          content: [],
        };
        this.priceList.push(data);
      }
    },
    changeSort(list, type, index) {
      let data = this[list][index];
      this[list].splice(index, 1);
      //上移
      if (type == 1) {
        this[list].splice(index - 1, 0, data);
      }
      //下移
      if (type == 2) {
        this[list].splice(index + 1, 0, data);
      }
    },
    //删除节点
    delItem(list, index) {
      this[list].splice(index, 1);
    },
    //编辑物品弹窗
    addGoodsDia(listName, index, content) {
      this.listName = listName;
      this.index = index;
      this.goods_list = content;
      this.addgoods = !this.addgoods;
    },
    //获取奖励物品
    getGoods(list) {
      this.$set(this[this.listName][this.index], "content", list);
    },
    //上传成功
    handleAvatarSuccess(res, index, listName) {
      if (res.code === 0) {
        this.$set(this[listName][index], "reward_img", res.data.pic);
        this.$set(this[listName][index], "reward_img_str", res.data.path);
      }
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
    },
    emitImg(data) {
      let { path, pic } = data;
      this.info.top_image = pic;
      this.info.top_image_str = path;
      this.$refs["ruleForm"].validateField(["top_image"]);
    },
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.rule-Form {
  ::v-deep .el-form-item__content {
    height: auto;
  }
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}
.box {
  position: relative;
  padding-left: 120px;
  box-sizing: border-box;
  margin-top: -20px;
  &:hover .shadow {
    display: flex;
  }
  .img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    box-sizing: border-box;
    position: absolute;
    left: 120px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
.checkbox {
  padding: 20px 30px;
  margin-right: 50px;
  border-radius: 10px;
  cursor: pointer;
  .big_word {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
.list_item {
  padding: 20px;
  background: #f5f5f5;
  width: 700px;
  border-radius: 10px;
  margin-bottom: 14px;
  .item_title {
    display: inline-block;
    width: 80px;
    font-weight: 700;
  }
}
.reward_img {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .avatar {
    width: 100px;
    height: 100px;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
</style>
<style>
.btnbox .el-button + .el-button {
  margin-left: 0px;
}
</style>
